const startSecondsOnPage = () => {
  window.performance.mark('generalSecondsOnPageStart');
};

const recordTemplate = (template: string) => {
  window.lucid?.kissMetrics?.set({
    template
  });
};

const recordLanguage = (language: string) => {
  window.lucid?.kissMetrics?.set({
    'Drupal Language': language
  });
};

const recordSecondsOnPage = (pathname: string) => {
  try {
    window.performance.mark('generalSecondsOnPageEnd');
    window.performance.measure(
      'generalSecondsOnPage',
      'generalSecondsOnPageStart',
      'generalSecondsOnPageEnd'
    );

    const measure = performance.getEntriesByName('generalSecondsOnPage')[0];
    const secondsOnPage = (measure.duration / 1000).toFixed(1);

    window.lucid?.kissMetrics?.set({
      generalSecondsOnPage: `${pathname} ${secondsOnPage}s`
    });
  } catch (e) {
    console.log('recordSecondsOnPage failure', e);
  }

  window.performance.clearMarks('generalSecondsOnPageStart');
  window.performance.clearMarks('generalSecondsOnPageEnd');
  window.performance.clearMeasures('generalSecondsOnPage');
};

const recordSecondsToLoad = () => {
  let secondsToLoad;
  const timing = window.performance.getEntriesByType('navigation');
  // Safari is missing the navigation entry and stores data with
  // time since epoch strings
  if (timing.length === 0) {
    secondsToLoad =
      (new Date(window.performance.timing.loadEventEnd).getTime() -
        new Date(window.performance.timing.navigationStart).getTime()) /
      1000;
  } else {
    secondsToLoad = timing[0].duration / 1000;
  }
  window.lucid?.kissMetrics?.set({
    generalSecondsToLoad: `${window.location.pathname} ${secondsToLoad.toFixed(
      1
    )}s`
  });
};

const recordVisitedPage = (pathname: string) => {
  window.lucid?.kissMetrics?.set({
    'visited page': pathname
  });
};

const recordLandedOnPage = (pathname: string) => {
  window.lucid?.kissMetrics?.set({
    generalLandedOnPage: pathname
  });
};

const recordUserBounce = (pathname: string) => {
  window.lucid?.kissMetrics?.set({
    generalUserBounce: pathname
  });
};

export {
  startSecondsOnPage,
  recordSecondsOnPage,
  recordSecondsToLoad,
  recordLandedOnPage,
  recordVisitedPage,
  recordUserBounce,
  recordTemplate,
  recordLanguage
};
